import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { IUser } from '../../types/users'
import { AuthStyles } from './auth.module'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import { useSession } from '../../context/SessionContext'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import { JustiInputText } from '../../components/InputText'
import RecoveryPasswordDialog from './RecoveryPasswordDialog'
import Alert, { ActionsOptType } from '../../components/Alert'
import { IFormChangeConfirmPassword } from '../../types/forms'

// Define IDialogOpen interface
interface IDialogOpen {
    open: boolean
    user?: IUser 
    setOpen: (newState: boolean) => void
  }
  
/**
 * Custom `CapturePassword` component declaration.
 * This component is used to capture and validate passwords
 * @param {boolean} open
 * @param {Object} user
 * @param {Funtion} setOpen
 * @return CapturePassword
*/
const CapturePassword = ({
    open,
    user,
    setOpen,
  }: IDialogOpen): JSX.Element => {
  const classes = AuthStyles()
  const [openRecoveryPassword, setopenRecoveryPassword] = useState(false)
  const { control, handleSubmit, errors } = useForm<IFormChangeConfirmPassword>()
  const { changePasswordPassport } = useSession()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  /**
   * This method is used to close dialog
   * @Return {void}
  */
  const handleClose = () => {
    setOpen(false)
  }

  /**
   * This method is used to validate passwords
   * @param {String} password
   * @param {String} passwordConfirm
   * @Return {void}
  */
  const onSubmit = ({ password, passwordConfirm }: IFormChangeConfirmPassword) => {
    if (password !== passwordConfirm) {
      setAlertOptions({
        message: 'Las contraseñas deben ser iguales.',
        open: true,
        type: 'error',
      })
      return;
    }
    if (changePasswordPassport && user)
    {
      changePasswordPassport(user, password)
      /* setAlertOptions({
        message: 'La contraseña a sido actualizada con exito.',
        open: true,
        type: 'info',
      }) */
      openRecoveryPasswordDialog()
    }
  }

  /**
   * This method is used to open openRecoveryPassword
   * @Return {void}
  */
  const openRecoveryPasswordDialog = () => {
    setopenRecoveryPassword(true)
  } 

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <RecoveryPasswordDialog
        open={openRecoveryPassword}
        setOpen={setopenRecoveryPassword}
      /> 
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <DialogContent>
      <form
        className={classes.form}
        noValidate
        onSubmit={handleSubmit(onSubmit)}
      >
        <h3>Recuperar contraseña</h3>
        <p>Por favor ingrese una contraseña valida.</p>
        <JustiInputText
            name={'password'}
            copy={'Contraseña'}
            errorMessage={'Contraseña inválida'}
            type={'password'}
            errors={errors}
            control={control}
          /> 
          <JustiInputText
            name={'passwordConfirm'}
            copy={'Validar Contraseña'}
            errorMessage={'Contraseña inválida'}
            type={'password'}
            errors={errors}
            control={control}
          /> 
          <DialogActions >
            <Button onClick={handleClose} style={{ color: 'red' }}>
              CANCELAR
            </Button>
            <Button
              style={{ marginTop: '2.5vh' }}
              type="submit"
              disabled={Object.keys(errors).length > 0}
              variant="contained"
              className={classes.submit}
            >
              RECUPERAR
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export default CapturePassword